module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_6_3.e81aeece.png";